interface HeaderProps {
  today: string; // YYYY-MM-DD
  doneCount: number;
  totalCount: number;
}

function format(date: string): string {
  const [y, m, d] = date.split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
}

export default function Header({ today, doneCount, totalCount }: HeaderProps) {
  return (
    <header className="header">
      <div className="header__date">{format(today)}</div>
      <div className="header__count">{doneCount} of {totalCount} done</div>
    </header>
  );
}
